import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { ContentLayout } from '../../components/ContentLayout';
import { ConfirmationSmsCodeForm } from '../../components/ConfirmationSmsCodeForm';
import { EEventType, ETwoFactorType } from '../../../index';
import { isValidCode } from '../../utils/validation';
import { EActiveView } from '../../types/view';
import { trackTwoFactorCannotConfirmClick, trackTwoFactorClose, trackTwoFactorContinueClick, trackTwoFactorPopupOpen } from '../../utils/tracking';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { HelpContainer } from '../HelpContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TwoFactorWithEmailViewContainer(_ref) {
  var isSubmitting = _ref.isSubmitting,
    hasCodeError = _ref.hasCodeError,
    codeError = _ref.codeError,
    reset = _ref.reset,
    emit = _ref.emit,
    authenticate = _ref.authenticate,
    changeView = _ref.changeView;
  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    changed = _React$useState4[0],
    setChanged = _React$useState4[1];
  // CODE
  var codeRef = React.useRef(null);
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    code = _React$useState6[0],
    setCode = _React$useState6[1];
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isCodeInvalid = _React$useState8[0],
    setCodeInvalid = _React$useState8[1];
  var validateCode = React.useCallback(function (code) {
    if (!isValidCode(code)) {
      if (codeRef.current) {
        codeRef.current.focus();
      }
      return;
    }
    authenticate({
      code: code
    });
    emit(EEventType.TwoFactorContinueClick);
    setChanged(false);
  }, [emit, authenticate]);
  var handleCantConfirmClick = React.useCallback(function () {
    trackTwoFactorCannotConfirmClick(ETwoFactorType.Email);
    emit(EEventType.TwoFactorCannotConfirmClick);
  }, [emit]);
  var handleCodeChange = React.useCallback(function (e) {
    var value = e.currentTarget.value;
    var nextValue = value.replace(/\D+/g, '');
    if (nextValue.length > 4) {
      return;
    }
    setCode(nextValue);
    setChanged(true);
    setCodeInvalid(isValidCode(nextValue));
    validateCode(nextValue);
  }, [validateCode]);
  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    trackTwoFactorContinueClick(ETwoFactorType.Email);
    if (isSubmitting) {
      return;
    }
    if (isCodeInvalid) {
      if (codeRef.current) {
        codeRef.current.focus();
      }
      return;
    }
    validateCode(code);
  }, [code, isCodeInvalid, isSubmitting, validateCode]);
  var switchToRegister = React.useCallback(function () {
    trackTwoFactorClose(ETwoFactorType.Email);
    reset();
    changeView(EActiveView.AuthenticationRegistration);
  }, [reset, changeView]);
  React.useEffect(function () {
    trackTwoFactorPopupOpen(ETwoFactorType.Email);
  }, []);
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsx(SubtitleLayout, {
      children: "\u0412\u044B \u0440\u0430\u043D\u044C\u0448\u0435 \u043D\u0435 \u0437\u0430\u0445\u043E\u0434\u0438\u043B\u0438 \u0441 \u044D\u0442\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430. \u0414\u043B\u044F \u0437\u0430\u0449\u0438\u0442\u044B \u0432\u0430\u0448\u0435\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u0432\u0430\u043C email \u0441 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u044B\u043C \u043A\u043E\u0434\u043E\u043C \u0441 \u043F\u043E\u0447\u0442\u044B noreply@cian.ru. \u0415\u0441\u043B\u0438 \u0432\u044B \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043F\u0438\u0441\u044C\u043C\u043E, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0430\u043F\u043A\u0443 \u0441\u043F\u0430\u043C."
    }), /*#__PURE__*/_jsx(ContentLayout, {
      children: /*#__PURE__*/_jsx(ConfirmationSmsCodeForm, {
        isSubmitting: isSubmitting,
        handleSubmit: handleSubmit,
        submitButtonText: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
        codeRef: codeRef,
        code: code,
        onCodeChange: handleCodeChange,
        codeError: touched && !changed ? codeError : undefined,
        isCodeInvalid: touched && (isCodeInvalid || hasCodeError && !changed),
        resendAvailable: false,
        resendTimeout: null,
        buttons: /*#__PURE__*/_jsx(Button, {
          "data-name": "SwitchToRegisterBtn",
          fullWidth: true,
          theme: "fill_secondary",
          onClick: switchToRegister,
          children: "\u041E\u0442\u043C\u0435\u043D\u0430"
        })
      })
    }), /*#__PURE__*/_jsx(HelpContainer, {
      text: "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
      onClick: handleCantConfirmClick
    })]
  });
}